import useServiceDialog from './useServiceDialog';
import { logoutSession } from '../../utils/session';
import { parseJwt } from '../../parseJwt';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaBell,
  FaTimes,
  FaCalendarAlt,
  FaCheckCircle,
  FaClipboardList,
  FaHome,
  FaSignOutAlt,
  FaTools,
  FaUser,
  FaUserCog
} from 'react-icons/fa';

const MENU_ITEMS = [
  { label: 'Ana Sayfa', icon: FaHome, to: '/technical-service/dashboard' },
  { label: '\u0130\u015flerim', icon: FaClipboardList, to: '/technical-service/my-jobs' },
  { label: 'Tamamlad\u0131klar\u0131m', icon: FaCheckCircle, to: '/technical-service/completed-jobs' },
  { label: 'Takvim', icon: FaCalendarAlt, to: '/technical-service/calendar' },
  { label: 'Bildirimler', icon: FaBell, to: '/technical-service/notifications' },
  { label: 'Profil', icon: FaUser, to: '/technical-service/profile' }
];

export const getUserInfoFromToken = () => {
  const token = localStorage.getItem('token');
  if (!token) return { name: 'Teknik Servis', email: '' };

  try {
    const decoded = parseJwt(token);
    return {
      name:
        decoded.UserName ||
        decoded.name ||
        decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] ||
        'Teknik Servis',
      email:
        decoded.email ||
        decoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] ||
        ''
    };
  } catch (error) {
    return { name: 'Teknik Servis', email: '' };
  }
};

export const formatPersonnelToday = () =>
  new Intl.DateTimeFormat('tr-TR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    timeZone: 'Europe/Istanbul'
  }).format(new Date());

const TechnicalServicePersonnelShell = ({
  children,
  title,
  subtitle,
  notificationCount = 0,
  hideTopbar = false,
  shellClassName = '',
  notifications = []
}) => {
  const location = useLocation();
  const user = getUserInfoFromToken();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const notificationRef = useRef(null);
  const closeNotifications = useCallback(() => setNotificationOpen(false), []);
  useServiceDialog(notificationRef, notificationOpen, closeNotifications);
  useEffect(() => setNotificationOpen(false), [location.pathname]);

  const logout = async () => {
    await logoutSession();
    window.location.href = '/';
  };

  return (
    <div className={`service-personnel-shell ${shellClassName}`.trim()}>
      <aside className="service-personnel-sidebar">
        <div className="service-personnel-brand">
          <FaTools />
          <span>Star Crane</span>
        </div>

        <nav className="service-personnel-menu">
          {MENU_ITEMS.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.to;
            return (
              <Link key={item.label} to={item.to} className={isActive ? 'active' : ''} aria-current={isActive ? 'page' : undefined}>
                <Icon />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="service-personnel-user service-personnel-user-card">
          <div className="service-personnel-avatar">
            <FaUserCog />
          </div>
          <div>
            <strong>{user.name}</strong>
            <span>{'Teknik Saha Personeli'}</span>
          </div>
          <button type="button" className="service-personnel-logout" onClick={logout}>
            <FaSignOutAlt />
            <span>{'\u00c7\u0131k\u0131\u015f Yap'}</span>
          </button>
        </div>
      </aside>

      <main className="service-personnel-main">
        {!hideTopbar && (
          <header className="service-personnel-topbar">
            <div>
              <p>{subtitle || formatPersonnelToday()}</p>
              <h1>{title || `Merhaba, ${user.name}`}</h1>
            </div>
            <div className="service-personnel-top-actions">
              <button type="button" aria-label="Bildirimler" aria-expanded={notificationOpen} aria-controls="personnel-notifications" onClick={() => setNotificationOpen((prev) => !prev)}>
                <FaBell />
                {notificationCount > 0 && <span>{notificationCount}</span>}
              </button>
              {notificationOpen && (
                <>
                <div className="service-notification-backdrop" onClick={closeNotifications} />
                <div className="service-notification-popover" id="personnel-notifications" ref={notificationRef} role="dialog" aria-modal="true" aria-label="Bildirimler" tabIndex={-1}>
                  <button type="button" className="service-notification-close" aria-label="Bildirimleri kapat" onClick={closeNotifications}><FaTimes /></button>
                  <strong>{'Bildirimler'}</strong>
                  {notifications.length > 0 ? (
                    notifications.slice(0, 5).map((item) => (
                      <div key={item.id || item.requestNo || item.subject}>
                        <span>{item.title}</span>
                        <small>{item.description}</small>
                      </div>
                    ))
                  ) : (
                    <p>{'G\u00f6sterilecek bildirim yok.'}</p>
                  )}
                  <Link className="service-notification-all" to="/technical-service/notifications" onClick={() => setNotificationOpen(false)}>
                    {'T\u00fcm bildirimleri g\u00f6r'}
                  </Link>
                </div>
                </>
              )}
            </div>
          </header>
        )}

        {children}
      </main>
    </div>
  );
};

export default TechnicalServicePersonnelShell;
